<template>
  <div class="infoContract" v-for="(client,key) in data" :key="key">
    <div class="infoContract__title">{{ client.head }}</div>
    <div class="infoContract__itemContainer">
      <div
        v-for="(item, key) in client.info" :key="key"
        class="infoContract__item" :class="{addr: item.title === 'Адрес'}"
      >
        <div class="infoContract__itemTitle">{{ item.title }}</div>
        <div class="infoContract__itemText">{{ item.value }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ClientComponents",
  props: ["data"]
};
</script>

<style scoped>
.addr {
  width: 100% !important;
}
</style>